import React from 'react'
import { Navigate, Outlet, Route, Routes } from 'react-router-dom'
import { PageLink, PageTitle } from '../../../../../_metronic/layout/core'
import DealerPriceListTable from './components/DealerPriceListTable'
import DealerPriceListForm from './components/DealerPriceListForm'

const crmBreadcrumb: PageLink = { title: 'CRM', path: '/', isSeparator: false, isActive: false }
const crmDealerPriceListBreadcrumb: PageLink = {
  title: 'Dealer Price Lists',
  path: '/crm/dealer-price-lists',
  isSeparator: false,
  isActive: true,
}

function DealerPriceListPage() {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='/'
          element={
            <>
              <PageTitle breadcrumbs={[crmBreadcrumb]}>Dealer Price Lists</PageTitle>
              <DealerPriceListTable />
            </>
          }
        />

        <Route
          path='/add'
          element={
            <>
              <PageTitle breadcrumbs={[crmBreadcrumb, crmDealerPriceListBreadcrumb]}>
                Add Dealer Price List
              </PageTitle>
              <DealerPriceListForm />
            </>
          }
        />

        <Route
          path='/edit/:id'
          element={
            <>
              <PageTitle breadcrumbs={[crmBreadcrumb, crmDealerPriceListBreadcrumb]}>
                Edit Dealer Price List
              </PageTitle>
              <DealerPriceListForm />
            </>
          }
        />
      </Route>

      <Route path='*' element={<Navigate to='/error/404' />} />
    </Routes>
  )
}

export default DealerPriceListPage

